"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeliveryOutlineIcon = void 0;
var React = __importStar(require("react"));
function DeliveryOutlineIcon(props) {
  var _a, _b, _c, _d;
  return React.createElement("svg", __assign({
    width: (_a = props.width) !== null && _a !== void 0 ? _a : 24,
    height: (_b = props.height) !== null && _b !== void 0 ? _b : 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: (_c = props.fill) !== null && _c !== void 0 ? _c : "#191C22",
    viewBox: (_d = props.viewBox) !== null && _d !== void 0 ? _d : "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M19.275 5.95h-4.15V4.13c0-.55-.45-1-1-1H1.395c-.55 0-1 .45-1 1v12.8c0 .5.38.9.86.97v.02h.1c.01 0 .02.01.04.01h.84a3.445 3.445 0 0 0 3.4 2.94c1.73 0 3.15-1.28 3.4-2.94h5.71c.01 0 .02-.01.04-.01h.19c.27 1.64 1.68 2.9 3.4 2.9s3.13-1.26 3.4-2.9h1.83v-6.79l-4.33-5.18Zm-.94 2 2.07 2.48h-5.29V7.95h3.22Zm3.26 7.97h-.1a3.459 3.459 0 0 0-3.13-2.01c-1.39 0-2.58.82-3.13 2.01h-.13v-3.49h6.48v3.49h.01Zm-3.22 2.9c-.61 0-1.13-.37-1.34-.9a1.45 1.45 0 0 1 1.27-2c.02 0 .05-.01.07-.01.02 0 .05.01.07.01a1.45 1.45 0 0 1-.07 2.9ZM2.395 5.13h10.72v10.79h-4.38a3.437 3.437 0 0 0-3.1-1.96c-1.37 0-2.54.8-3.1 1.96h-.14V5.13Zm4.6 12.8c-.21.55-.74.94-1.36.94-.62 0-1.15-.39-1.36-.94v-.01c-.06-.16-.1-.33-.1-.51 0-.8.65-1.46 1.46-1.46.81 0 1.46.65 1.46 1.46-.01.18-.04.35-.1.52 0-.01 0-.01 0 0Z"
  }));
}
exports.DeliveryOutlineIcon = DeliveryOutlineIcon;